import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';

export function DeviceStep3Assignment({ formData, onChange, tenants }) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
        Assign this device to a customer: <span className="text-red-500">*</span>
      </p>

      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Assign to Customer <span className="text-red-500">*</span></Label>
        <Select value={formData.tenant_id || ''} onValueChange={(v) => onChange('tenant_id', v)}>
          <SelectTrigger className="border-slate-300 dark:border-slate-600 dark:bg-slate-700">
            <SelectValue placeholder="Select a customer" />
          </SelectTrigger>
          <SelectContent>
            {tenants.map((t) => (
              <SelectItem key={t.id} value={t.id}>
                {t.name} ({t.code})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-xs text-slate-500 dark:text-slate-400">
          Device must be assigned to a customer for provisioning
        </p>
      </div>

      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Location</Label>
        <Input
          value={formData.location}
          onChange={(e) => onChange('location', e.target.value)}
          placeholder="Warehouse A, Delhi"
          className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Notes</Label>
        <textarea
          value={formData.notes}
          onChange={(e) => onChange('notes', e.target.value)}
          placeholder="Any additional notes about this device..."
          rows={3}
          className="w-full border border-slate-300 dark:border-slate-600 dark:bg-slate-700 text-slate-900 dark:text-slate-100 p-3 text-sm rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
  );
}
